import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["disablable", "clearable"]

  disable() {
    for (const target of this.disablableTargets) {
      target.disabled = true
    }
  }

  clear() {
    for (const target of this.clearableTargets) {
      switch (target.type) {
        case "date":
        case "number":
        case "password":
        case "search":
        case "select-multiple":
        case "select-one":
        case "text":
        case "textarea":
          target.value = ""
          break
        case "checkbox":
        case "radio":
          target.checked = target.value == ""
      }
    }
  }
}
